import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"
import padding from "@irati/ui/src/global/padding"

export const StyledGreeting = styled.div`
  margin-bottom: ${padding.small};
  margin-top: ${padding.small};
`

export const Wrapper = styled(Flex)`
  margin: ${padding.small} auto;
`

export const StyledTitle = styled.div`
  padding-left: ${padding.tiny};
`

export const StyledIcon = styled(Icon)`
  margin-bottom: -3px;
  margin-right: 10px;
`
